:host {
  display: block;
  min-width: 0;
}

.line-item-note {
  display: flex;
  align-items: flex-start;
  gap: 0.25em;
  min-height: 1.5em;

  &--clickable {
    cursor: pointer;
  }

  // `anywhere` breaks mid-word instead of pushing the whole word to the
  // clamped-away line 2, and keeps this from forcing a wider flex ancestor.
  &__text {
    line-height: 1.4;
    flex: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: anywhere;
    transition: all 0.2s;
  }

  &--is-expanded .line-item-note__text {
    display: block;
    line-clamp: unset;
    -webkit-line-clamp: unset;
    overflow: visible;
    text-overflow: unset;
  }

  &__toggle {
    background: none;
    border: none;
    color: var(--sc-color-gray-500);
    cursor: pointer;
    padding: 0;
    align-self: flex-start;
    transition: opacity 0.2s ease;
    border-radius: var(--sc-border-radius-small);

    &:hover {
      opacity: 0.8;
    }

    &:focus-visible {
      outline: 2px solid var(--sc-color-primary-500);
      outline-offset: 2px;
    }

    &:focus {
      outline: 2px solid var(--sc-color-primary-500);
      outline-offset: 2px;
    }
  }
}
